import * as React from 'react';
import { observer, inject } from 'mobx-react';
import HistorieStore from '../stores/HistorieStore';
import { Grid, Table, TableRow, TableCell, TableBody, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import Historie from 'src/models/Historie';

export interface IHistoryListingProps {
    historieStore?: HistorieStore;
    historyRecords?: Historie[];
}

@inject('historieStore')
@observer
export default class HistoryListing extends React.Component<IHistoryListingProps> {

    private historie: Historie[];

    constructor(props: Readonly<IHistoryListingProps>) {
        super(props);
        if(this.props.historyRecords == null) {
            this.historie = this.props.historieStore.historieForID;
        } else {
            this.historie = this.props.historyRecords;
        }
    }

    public render() {
        return (<div>
            {this.historie.map((historyRecord: Historie) => (
                <ExpansionPanel>
                    <ExpansionPanelSummary>
                        <Typography style={{flexBasis: '45%'}}>{historyRecord.name}</Typography>
                        <Typography>{historyRecord.date.toLocaleString()}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            <Table>
                                <TableBody>
                                    <TableRow hover key={historyRecord.entityType + historyRecord.date.toLocaleDateString()}>
                                        <TableCell>Uživatel</TableCell>
                                        <TableCell>{historyRecord.user}</TableCell>
                                    </TableRow>
                                    <TableRow hover key={historyRecord.entityType + historyRecord.date.toLocaleDateString()}>
                                        <TableCell>ID entity</TableCell>
                                        <TableCell>{historyRecord.entityID}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Grid>
                        <Grid item xs={12} style={{marginTop: '15px'}}>
                            {(historyRecord.childRecords.length > 0)?<HistoryListing historyRecords={historyRecord.childRecords} />:<div />}
                        </Grid>
                    </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            ))}
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/HistoryListing.tsx